export const ROLE_FIT_LABELS = {
    VERY_HIGH: 'VERY_HIGH',
    HIGH: 'HIGH',
    MEDIUM: 'MEDIUM',
    LOW: 'LOW',
    VERY_LOW: 'VERY_LOW'
};
